import { Input, OnDestroy, Directive } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Unsubscriber } from 'app/utils/angular-utils/classes';
import * as _ from 'lodash';

export type FormConstructor = (formBuilder: FormBuilder, ...args: any[]) => FormGroup;

@Directive()
export abstract class FormStateDirective implements OnDestroy {
  @Input()
  parentForm: FormGroup;

  public form: FormGroup;
  protected unsubscriber = new Unsubscriber();

  constructor(protected formBuilder: FormBuilder) {}

  protected linkFormToParent(groupName: string, formConstructor: FormConstructor, ...args: any[]) {
    this.form = this.parentForm.get(groupName) as FormGroup;
    if (!this.form) {
      this.form = formConstructor(this.formBuilder, ...args);
      this.parentForm.setControl(groupName, this.form);

      // for debugging, set a name field on each control
      _.set(this.form, 'name', groupName);
    }
    this.form.enable();
  }

  ngOnDestroy() {
    this.unsubscriber.complete();
    this.form.disable();
  }
}
